<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      unit="模拟器"
      id-key="CoopId"
      :data="data"
      form-label-width="100px"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      :before-save="onBeforeSave"
      @details-opened="onDetailsOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        基础信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="归属机构" prop="DpId">
                <span>{{ data.DpName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模拟器编号" prop="SimulatorNo">
                <span>{{ data.SimulatorNo }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="模拟器品牌" prop="SimulatorBrand">
                <span>{{ data.SimulatorBrand }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模拟器类型" prop="SimulatorType">
                <span>{{ data.SimulatorType }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="模拟器型号" prop="SimulatorModel">
                <span>{{ data.SimulatorModel }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产厂家" prop="Manufactor">
                <span>{{ data.Manufactor }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="培训车型" prop="CarTypes">
                <span>{{ data.CarTypes }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入库日期" prop="InDate">
                <span>{{ $commonJs.toDateString(data.InDate) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="经度" prop="GpsLng">
                <span>{{ data.GpsLng }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度" prop="GpsLat">
                <span>{{ data.GpsLat }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="图片" prop="PicUrls" class="is-required" :class="PicUrls.length?'file-form2':''">
                <div>
                  <template v-if="PicUrls.length">
                    <el-image class="viewImg" v-for="item in PicUrls" :key="item.url" :src="host + item.url" :preview-src-list="[host + item.url]"></el-image>
                  </template>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                <span>{{ data.Remark }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        备案信息
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="备案人">
              {{data.RecordUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案时间">
              {{data.RecordTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案状态">
              <span v-if="data.RecordStatus==0" style="color:#f11;">未备案</span>
              <span v-else-if="data.RecordStatus==1">备案中</span>
              <span v-else-if="data.RecordStatus==2" style="color:#f11;">备案失败</span>
              <span v-else-if="data.RecordStatus==3">备案通过</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="data.RecordRemark">
            <el-form-item label="备案备注">
              {{data.RecordRemark}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案审核状态">
              <span v-if="data.ExamStatus==0">待审核</span>
              <span v-else-if="data.ExamStatus==1">审核中</span>
              <span v-else-if="data.ExamStatus==2">审核失败</span>
              <span v-else-if="data.ExamStatus==3">审核成功</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案审核时间">
              {{data.ExamTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案审核意见">
              {{data.ExamRemark}}
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import api from "@/api/op/simulator";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
      data: {
        SimulatorId: 0,
        SimulatorNo: null,
        SimulatorBrand: null,
        SimulatorType: null,
        SimulatorModel: null,
        Manufactor: null,
        CarTypes:'',
        InDate: null,
        PicUrls: "",
        Remark: null,
        DpId: 0,
        DpName: "",
        SimulatorCode: "",
        GpsLng: null,
        GpsLat: null,
        RecordStatus: 0,
        RecordTime: "",
        RecordUserName: "",
        RecordRemark: "",
        ExamStatus: 0,
        ExamTime: "",
        ExamRemark: ""
      },
      loginInfo,
      api,
      rules: {
        DpId: [{ required: true, message: "请选择归属机构" }],
        SimulatorNo: [{ required: true, message: "请填写模拟器编号" }],
        SimulatorBrand: [{ required: true, message: "请选择模拟器品牌" }],
        SimulatorType: [{ required: true, message: "请选择模拟器类型" }],
        SimulatorModel: [{ required: true, message: "请选择模拟器型号" }],
        Manufactor: [{ required: true, message: "请选择生产厂家" }],
        CarTypes: [{ required: true, message: "请选择培训车型" }],
        InDate: [{ required: true, message: "请选择入库日期" }],
        GpsLng: [{ required: true, message: "请填写经度" }],
        GpsLat: [{ required: true, message: "请填写纬度" }],
      },
      PicUrls: [],
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  methods: {
    onCreateOpened() {
    },
    onEditOpened(data) {
      var parr = data["PicUrls"].split(",");
      parr.forEach((n) => {
        this["PicUrls"].push({ url: '/api' + n });
      });
    },
    onDetailsOpened(row) {
      this.onEditOpened(row);
    },
    
    onBeforeSave() {
      
    },
    onClosed() {
      this.PicUrls = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.viewImg{
  width: 120px;
  height: 120px;
  margin-right: 10px;
}
</style>